module.exports = __webpack_public_path__ + "static/media/hero-image.4a5f1737.png";